export default "__VITE_PUBLIC_ASSET__16ddcec2__"